export default __webpack_public_path__ + "static/media/closeIcon.63668970.svg";